import { Reveal } from "./Reveal";

// Numbered manifesto-chapter section header: eyebrow + big display headline.
export function SectionHeader({ no, eyebrow, title, dark = false, className = "", titleClassName = "" }) {
  return (
    <div className={`mb-12 md:mb-16 ${className}`}>
      <Reveal>
        <div className="flex items-center gap-4">
          {no && <span className={dark ? "tech-no-dark" : "tech-no"}>{no}</span>}
          <span className={`h-px w-10 ${dark ? "bg-zinc-700" : "bg-zinc-300"}`} aria-hidden="true" />
          <p className={dark ? "eyebrow-dark" : "eyebrow"}>{eyebrow}</p>
        </div>
      </Reveal>
      <Reveal delay={0.08}>
        <h2
          className={`h-display mt-6 text-4xl sm:text-5xl lg:text-6xl ${
            dark ? "text-zinc-50" : "text-charcoal"
          } ${titleClassName}`}
        >
          {title}
        </h2>
      </Reveal>
    </div>
  );
}
